import { Action, createReducer, on, props } from '@ngrx/store';

import * as actions from './query.actions';
import { QuerySplitState , QueryProcessState } from './query.model';

// 1: Estados Iniciales //////////////////////////////////////
    // Split State
    export const initialState: QuerySplitState = {
        split : false
    };
    // Process State
    export const initialQueryState: QueryProcessState = {
        stateProcess : 'Initial', options : {}
    };

// 2 Reductores y Funnciones de Gestion //////////////////////////////////////
    // Split State
    const _splitPageReducer = createReducer(
    initialState,
    on(actions.setSplitPageState, (state , {split}) => ({ ...state, split})),
    on(actions.resetSplit, (state) => ({ split: false }))
    ); 

    export function splitPageQueryReducer(state, action) {
        return  _splitPageReducer(state, action);
    }
    // Process State
    const _processReducer = createReducer(
    initialQueryState,
    on(actions.setProcessState, (state , {stateProcess , options}) => ({ ...state, stateProcess , options})),
    on(actions.resetProcess, (state) => ({stateProcess : 'Initial', options : {}}))
    );

    export function processQueryReducer(state, action) {
        return  _processReducer(state, action);
    }

// 3: Interface General de estados del componente //////////

export interface QueryStates {
    splitPageQueryState: QuerySplitState;
    processQueryState: QueryProcessState;
}

// 4: map de estados -- lista de estado a insertar en modulo -- aun no funciona
export const queryReducer = {
    splitPageQueryState: splitPageQueryReducer,
    processQueryState: processQueryReducer
}
